import { z } from "zod";

/** One workspace the signed-in operator is a live member of (not deleted or suspended). */
export const workspaceMembershipSchema = z.object({
  id: z.string(),
  name: z.string(),
  role: z.enum(["owner", "member"]),
});

export const workspaceMembershipListSchema = z.array(workspaceMembershipSchema);

export type WorkspaceMembership = z.infer<typeof workspaceMembershipSchema>;
